// extracted by mini-css-extract-plugin
export default {"icon":"hKOqqo","text":"t2QNAK","button":"cHD93p","textButton":"ZUTzNU","iconButton":"fUBtWr","animated":"PRc38l","verticalAlign":"ZHHFI1"};